// ========================= PHYSICAL ART METADATA =========================

export const ADD_PHYSICAL_ART = "ADD_PHYSICAL_ART";
export const ADD_PHYSICAL_ART_SUCCESS = "ADD_PHYSICAL_ART_SUCCESS";
export const ADD_PHYSICAL_ART_FAIL = "ADD_PHYSICAL_ART_FAIL";

export const GET_PHYSICAL_ART_BY_USER_ID = "GET_PHYSICAL_ART_BY_USER_ID";
export const GET_PHYSICAL_ART_BY_USER_ID_SUCCESS =
  "GET_PHYSICAL_ART_BY_USER_ID_SUCCESS";
export const GET_PHYSICAL_ART_BY_USER_ID_FAIL =
  "GET_PHYSICAL_ART_BY_USER_ID_FAIL";

export const GET_PHYSICAL_ART_BY_ID = "GET_PHYSICAL_ART_BY_ID";
export const GET_PHYSICAL_ART_BY_ID_SUCCESS = "GET_PHYSICAL_ART_BY_ID_SUCCESS";
export const GET_PHYSICAL_ART_BY_ID_FAIL = "GET_PHYSICAL_ART_BY_ID_FAIL";

export const GET_PHYSICAL_ART_BY_SELL_ITEM_ID =
  "GET_PHYSICAL_ART_BY_SELL_ITEM_ID";
export const GET_PHYSICAL_ART_BY_SELL_ITEM_ID_SUCCESS =
  "GET_PHYSICAL_ART_BY_SELL_ITEM_ID_SUCCESS";
export const GET_PHYSICAL_ART_BY_SELL_ITEM_ID_FAIL =
  "GET_PHYSICAL_ART_BY_SELL_ITEM_ID_FAIL";

// ========================= PHYSICAL ART SELL ITEMS =========================

export const ADD_PHYSICAL_SELLITEM = "ADD_PHYSICAL_SELLITEM";
export const ADD_PHYSICAL_SELLITEM_SUCCESS = "ADD_PHYSICAL_SELLITEM_SUCCESS";
export const ADD_PHYSICAL_SELLITEM_FAIL = "ADD_PHYSICAL_SELLITEM_FAIL";

export const GET_EXPLORE_PHYSICAL_ART = "GET_EXPLORE_PHYSICAL_ART";
export const GET_EXPLORE_PHYSICAL_ART_SUCCESS =
  "GET_EXPLORE_PHYSICAL_ART_SUCCESS";
export const GET_EXPLORE_PHYSICAL_ART_FAIL = "GET_EXPLORE_PHYSICAL_ART_FAIL";


export const LIKE_VIEW_PHYSICAL = "LIKE_VIEW_PHYSICAL";
export const LIKE_VIEW_PHYSICAL_SUCCESS = "LIKE_VIEW_PHYSICAL_SUCCESS";
export const LIKE_VIEW_PHYSICAL_FAIL = "LIKE_VIEW_PHYSICAL_FAIL";


// new 
export const P_GET_CANVAS_PAPER_SIZE = "P_GET_CANVAS_PAPER_SIZE";
export const P_GET_CANVAS_PAPER_SIZE_SUCCESS = "P_GET_CANVAS_PAPER_SIZE_SUCCESS";
export const P_GET_CANVAS_PAPER_SIZE_FAIL = "P_GET_CANVAS_PAPER_SIZE_FAIL";